<empresa tipo='F' titulo="Empresas Fornecedoras" rotaCadastrar='empresasfornecedoras/cadastrar'></empresa>